var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "105px",
    viewBox: "0 0 105 105",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "72F2F7D6-3A0F-4659-85F2-90DA2162FF88")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 52.5,
    cy: 52.5,
    r: 52.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetSheet",
    transform: "translate(-170.000000, -29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---1",
    transform: "translate(170.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#C2FCFB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.024676,31.0845697 C34.9078835,11.8590697 50.990051,12.0218197 52.571176,12.0830697 C54.1530185,12.0208624 70.235676,11.8595422 71.117676,31.0845697 C71.117676,31.0845697 74.245801,59.8563197 52.697176,60.0820697 L52.697176,60.0875384 C52.6547928,60.0875384 52.6130938,60.0854876 52.5707105,60.0854876 C52.5283273,60.0854876 52.4866283,60.0875384 52.444245,60.0875384 L52.444245,60.0820697 C30.894745,59.8557947 34.023745,31.0845697 34.023745,31.0845697 L34.024676,31.0845697 Z M92.084426,87.3243197 C92.3824685,83.1003447 92.0297385,74.5528197 84.627851,72.6708697 C74.703426,70.1477197 66.639601,64.4705447 66.639601,64.4705447 L59.166576,88.1042947 L54.795601,75.7202447 C63.184751,64.0157197 52.573276,64.4710697 52.573276,64.4710697 C52.573276,64.4710697 41.961801,64.0157897 50.350951,75.7202447 L45.982076,88.1137447 L38.505551,64.4712447 C38.505551,64.4712447 30.442601,70.1484197 20.517301,72.6715697 C13.120751,74.5521197 12.762001,83.0901947 13.060726,87.3169697 C13.060726,87.3169697 12.9745928,93.1890947 13.920011,95.5727697 C13.920011,95.5727697 28.369761,104.96467 52.572261,104.96467 L52.6187445,104.417795 L52.6057564,104.96467 C76.8082564,104.96467 91.2580064,95.5727697 91.2580064,95.5727697 C92.2034089,93.1904947 92.1172914,87.3169697 92.1172914,87.3169697 L92.084426,87.3243197 Z",
    id: "Shape",
    fill: "#009999",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Avatar.4b8d7e36.svg";
export { ForwardRef as ReactComponent };